import Storage from './Storage'

const Tool = (function () {
  let tool = {
    ss: {
      storage: new Storage({source: window.sessionStorage})
    },
    ls: {
      storage: new Storage({source: window.localStorage})
    }
  }

  // 设置cookie值
  tool.setCookie = function (name, value, seconds) {
    var exdate = new Date()
    exdate.setTime(exdate.getTime() + seconds)
    document.cookie = name + '=' + escape(value) +
      ((seconds == null) ? '' : ';expires=' + exdate.toGMTString())
  }

  // 获取cookies值
  tool.getCookie = function (name) {
    if (document.cookie.length > 0) {
      var start = document.cookie.indexOf(name + '=')
      if (start !== -1) {
        start = start + name.length + 1
        var end = document.cookie.indexOf(';', start)
        if (end === -1) end = document.cookie.length
        return unescape(document.cookie.substring(start, end))
      }
    }
    return ''
  }

  // 缓存值
  tool.ss.setItem = tool.ls.setItem = function (key, val, expired) {
    this.storage.setItem(key, val, expired)
  }

  // 获取值
  tool.ss.getItem = tool.ls.getItem = function (key) {
    return this.storage.getItem(key)
    //   return JSON.parse(this.storage.getItem(key))
    // } catch (err) {
    //   return null
    // }
  }

  // 删除缓存
  tool.ss.removeItem = tool.ls.removeItem = function (key) {
    this.storage.removeItem(key)
  }

  // 清除缓存
  tool.ss.clear = tool.ls.clear = function () {
    this.storage.clear()
  }

  tool.generateUUID = function () {
    var d = new Date().getTime()
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0
      d = Math.floor(d / 16)
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })
    return uuid
  }
  tool.isPC = function () {
    let userAgentInfo = navigator.userAgent;
    let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
    for (let v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        return false
      }
    }
    return true
  }
  // 动态加载css，id参数用于标示唯一，非必需
  tool.loadCSS = function (url, id, className) {
    if (id) {
      let dom = document.getElementById(id)
      if (dom) {
        dom.href = url
        return
      }
    }
    let link = document.createElement('link')
    id && (link.id = id)
    className && (link.className = className)
    link.rel = 'stylesheet';
    link.type = 'text/css'
    link.href = url
    document.querySelector('head').appendChild(link)
  }
  // 动态加载js，id参数用于唯一标示，非必需
  tool.loadScript = function (url, callback, id, className) {
    if (id) {
      let dom = document.getElementById(id)
      if (dom) {
        let flag = false
        callback && callback(flag)
        return
      }
    }
    var script = document.createElement('script');
    script.setAttribute('type', 'text/javascript')
    if (id) {
      script.setAttribute('id', id)
    }
    if (className) {
      script.setAttribute('class', className)
    }
    if (callback) {
      script.onload = script.onreadystatechange = function () {
        let flag = !this.readyState || this.readyState === 'loaded' || this.readyState === 'complete'
        callback(flag)
      };
      script.onerror = function (res) {
        let flag = false
        callback(flag)
      };
    }
    script.setAttribute('src', url)
    document.body.appendChild(script)
  }
  return tool
})()
window.$tool = Tool
